export default __webpack_public_path__ + "static/media/4.5b670953.jpg";